export default __webpack_public_path__ + "static/media/MockUp.263894da.png";